import { Bot } from '../types';
import ActiveState from './ActiveState';
import CbrtRangeForm from './CbrtRangeForm';

import './index.css';

interface Props {
  bot: Bot;
}

const Control: React.FC<Props> = (props: Props) => {
  const { bot } = props;

  return (
    <div className="detail-control-container">
      <ActiveState isActive={bot.isActive} botId={bot.botId} />
      <div className="detail-control-row">
        <div className="detail-control-item">
          <CbrtRangeForm botId={bot.botId} />
        </div>
      </div>
    </div>
  );
};

export default Control;
